import { Box, Grid, Typography, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import React, { Fragment, useEffect, useRef, useState } from "react";
import ldrrmc_logo from "../../assets/ldrrmc.png";
import leon_logo from "../../assets/leon_municipal_seal.png";
import moment from "moment";
// import { CBEWSL_SITE_CODE, CBEWSL_SITE_LOCATION } from "../../host";
import { PDFExport } from "@progress/kendo-react-pdf";
import html2canvas from "html2canvas";

const GeneratedBulletin = () => {
  const location = useLocation();
  const currentYear = moment().format("YYYY");
  const pdfExportComponent = React.useRef(null);
  const exportContentRef = useRef(null);
  console.log(location.state);

  const [formattedTriggerSource, setFormattedTriggerSource] = useState([
    {
      trigger: "ground_movement",
      tech_infos: [],
    },
    {
      trigger: "landslide_features",
      tech_infos: [],
    },
    {
      trigger: "earthquake",
      tech_infos: [],
    },
    {
      trigger: "rainfall",
      tech_infos: [],
    },
    {
      trigger: "on_demand",
      tech_infos: [],
    },
  ]);

  useEffect(() => {
    if (location.state.triggerSource) {
      const trigger_sources = location.state.triggerSource;
      const ground_movements = [
        "subsurface",
        "landslide features",
        "surficial",
      ];
      const temp = [];

      console.log("trigger_sources", trigger_sources)
      trigger_sources.forEach((row) => {
        const { source, description, info, latest_ts } = row;
        if (ground_movements.includes(source.toLowerCase())) {
          const existing_ground_movement = temp.find(
            (e) => e.trigger === "ground_movement"
          );
          console.log(existing_ground_movement);
          if (existing_ground_movement) {
            existing_ground_movement.tech_infos.push({
              description,
              info,
              latest_ts
            });
          } else {
            temp.push({
              trigger: "ground_movement",
              tech_infos: [{ description, info, latest_ts }],
            });
          }
        } else {
            temp.push({
              trigger: source.toLowerCase(),
              tech_infos: [{ description, info, latest_ts }],
            });
        }
      });
      console.log("temp", temp)
      setFormattedTriggerSource(temp);
    }
  }, []);
  
  const PageTemplate = (props) => {
    return (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          right: "10px",
        }}
      >
        Page {props.pageNum} of {props.totalPages}
      </div>
    );
  };

  const downloadAsImage = () => {
    if (exportContentRef.current) {
      html2canvas(exportContentRef.current, { scale: 2 })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/jpg");
          const link = document.createElement("a");
          link.href = imgData;
          link.download = `alert-bulletin-${moment().format(
            "YYYY-MM-DD HH:mm:ss"
          )}.jpg`;
          link.click();
        })
        .catch((error) => {
          console.error("Error capturing image:", error);
        });
    }
  };

  return (
    <div>
      <div ref={exportContentRef}>
        <Box
          sx={{
            marginTop: 5,
            marginBottom: 2,
            maxWidth: 800,
            height: "auto",
            border: "2px solid black",
          }}
        >
          <PDFExport
            pageTemplate={PageTemplate}
            keepTogether="typography"
            avoidLinks
            paperSize="A4"
            scale={0.7}
            margin="5mm"
            ref={pdfExportComponent}
            fileName={`alert-bulletin-${moment().format(
              "YYYY-MM-DD HH:mm:ss"
            )}`}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="flex-start"
              textAlign="center"
            >
              <Grid
                container
                // spacing={3}
                alignItems="center"
                justifyContent="flex-center"
              >
                <Grid
                  item
                  xs={2.5}
                  style={{ marginTop: -6, marginLeft: 26, textAlign: "right" }}
                >
                  <img
                    src={ldrrmc_logo}
                    alt="letter-header"
                    style={{
                      objectFit: "contain",
                      width: 205,
                      height: 160,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={7.75}
                  style={{
                    textAlign: "center",
                    marginTop: 20,
                    marginLeft: -45,
                  }}
                >
                  <Typography variant="body1" lineHeight={1.2} fontSize={19}>
                    <b>Republic of the Philippines</b>
                    <br />
                    <b>Province of Iloilo</b>
                    <br />
                    <b>Municipality of Leon</b>
                    <br />
                    <b>Community-based Early Warning System for Landslides</b>
                    <br />
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={1.75}
                  style={{ textAlign: "left", marginLeft: 6, marginTop: -1 }}
                >
                  <img
                    src={leon_logo}
                    alt="letter-header"
                    style={{
                      objectFit: "contain",
                      width: 100,
                      height: 100,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                style={{ marginBottom: 20, marginTop: 30 }}
              >
                <Typography variant="h5">
                  <b>CBEWS-L ALERT LEVEL INFORMATION: MAR-{currentYear}</b>
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              style={{ marginBottom: 20 }}
            >
              <Box
                sx={{
                  width: 600,
                  height: "auto",
                  border: "2px solid black",
                  padding: 2,
                }}
              >
                <Typography variant="body1">
                  Location: <strong>{location.state.siteLocation}</strong>
                </Typography>
                <Typography variant="body1">
                  Date/Time:{" "}
                  <strong>
                    {moment(location.state.currentAlertTs).format(
                      "MMMM D, YYYY, h:mm A"
                    )}
                  </strong>
                </Typography>
                <Typography variant="body1">
                  Alert Level Released:{" "}
                  <strong>{location.state.alertLevel}</strong>
                </Typography>
              </Box>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                style={{ marginLeft: 50, marginRight: 50 }}
              >
                <Typography variant="body1">
                  <b>
                    <u>AREA SITUATION:</u>
                  </b>
                </Typography>

                {/* {location.state.triggerSource.length === 0 ? (
                  <Typography variant="subtitle1">
                    No ground movement observed.
                  </Typography>
                ) : (
                  location.state.triggerSource.some(
                    (data) => data.source.toLowerCase() === "landslide features"
                  ) && (
                    <div>
                      <Typography variant="subtitle1">
                        <b>Landslide Features</b>
                      </Typography>

                      <Typography variant="subtitle1">
                        {location.state.triggerSource
                          .filter(
                            (data) =>
                              data.source.toLowerCase() === "landslide features"
                          )
                          .map((data) => (
                            <ul style={{ margin: 0 }}>
                              <li>{data.description}</li>
                            </ul>
                          ))}
                      </Typography>
                    </div>
                  )
                )}

                {location.state.triggerSource.some(
                  (data) => data.source.toLowerCase() === "rainfall"
                ) && (
                  <div>
                    <Typography variant="subtitle1">
                      <b>Rainfall</b>
                    </Typography>

                    <Typography variant="subtitle1">
                      {location.state.triggerSource
                        .filter(
                          (data) => data.source.toLowerCase() === "rainfall"
                        )
                        .map((data) => (
                          <ul style={{ margin: 0 }}>
                            <li>{data.description}</li>
                          </ul>
                        ))}
                    </Typography>
                  </div>
                )}

                {location.state.triggerSource.some((data) =>
                  ["earthquake", "surficial", "subsurface"].includes(
                    data.source.toLowerCase()
                  )
                ) && (
                  <div>
                    <Typography variant="subtitle1">
                      <b>Ground Movement</b>
                    </Typography>

                    <Typography variant="subtitle1">
                      {location.state.triggerSource
                        .filter((data) =>
                          ["earthquake", "surficial", "subsurface"].includes(
                            data.source.toLowerCase()
                          )
                        )
                        .map((data) => (
                          <ul style={{ margin: 0 }}>
                            <li>{data.description}</li>
                          </ul>
                        ))}
                    </Typography>
                  </div>
                )}

                {location.state.triggerSource.some((data) =>
                  data.source === "Extended"
                ) && (
                  <div>
                    <Typography variant="subtitle1">
                      {location.state.triggerSource
                        .filter((data) =>
                          data.source === "Extended"
                        )
                        .map((data) => (
                          <Typography variant="subtitle1">
                            No ground movement observed.
                          </Typography>
                        ))}
                    </Typography>
                  </div>
                )} */}

                {formattedTriggerSource.length > 0 ? (
                  formattedTriggerSource.map((data, index) => (
                    <Fragment key={index}>
                      <Typography variant="subtitle1">
                        <b>{data.trigger.replace("_", " ").toUpperCase()}</b>
                      </Typography>
                
                    {data.tech_infos.map((tech_info_data, techIndex) => (
                      <Fragment key={techIndex}>
                        <Typography variant="subtitle1">
                          {tech_info_data.description}
                        </Typography>
                        <ul>
                        <Typography variant="subtitle1" style={{ marginTop: -15 }}>
                          <li>
                            {moment(tech_info_data.latest_ts).format("LLL")}{" "}
                            : {tech_info_data.info}
                          </li>
                        </Typography>
                        </ul>
                      </Fragment>
                    ))}
                    </Fragment>
                  ))
                ) : (
                  <Typography variant="subtitle1">
                    No ground movement observed
                  </Typography>
                )}

                <Typography variant="subtitle1" style={{ marginTop: 20 }}>
                  <b>
                    <u>ELEMENTS AT RISK:</u>
                  </b>
                </Typography>
                <Typography variant="subtitle1">
                  {location.state.households}
                </Typography>
                <Typography variant="body1" style={{ marginTop: 20 }}>
                  <b>
                    <u>OTHER RECOMMENDATIONS:</u>
                  </b>
                </Typography>
                {location.state.communityRP !== "" && (
                  <Typography variant="subtitle1">
                    <b>For the Community:</b> {location.state.communityRP}
                  </Typography>
                )}
                {location.state.lewcRP !== "" && (
                  <Typography variant="subtitle1">
                    <b>For the Landslide Early Warning Committee (LEWC):</b>{" "}
                    {location.state.lewcRP}
                  </Typography>
                )}
                {location.state.barangayRP !== "" && (
                  <Typography variant="subtitle1">
                    <b>For the Barangay:</b> {location.state.barangayRP}
                  </Typography>
                )}
                {location.state.municipalResponse !== "" && (
                  <Typography variant="subtitle1">
                    <b>For the Municipality:</b>{" "}
                    {location.state.municipalResponse}
                  </Typography>
                )}
                {location.state.provincialResponse !== "" && (
                  <Typography variant="subtitle1">
                    <b>For the Province:</b> {location.state.provincialResponse}
                  </Typography>
                )}
                <Typography
                  variant="subtitle1"
                  style={{ marginTop: 20, marginBottom: 20 }}
                >
                  <b>NOTE:</b> This bulletin contains the official alert level
                  and recommended response of the MDRRMO Leon for Brgy. Marirong
                  and will hold true until a new bulletin is released.
                </Typography>
              </Grid>
            </Grid>
          </PDFExport>
        </Box>
      </div>

      <Grid
        item
        xs={12}
        style={{
          justifyContent: "center",
          textAlign: "center",
          marginTop: 20,
          marginBottom: 30,
        }}
      >
        <Button
          variant="contained"
          style={{
            color: 'white',
          }}
          onClick={() => {
            if (pdfExportComponent.current) {
              pdfExportComponent.current.save();
            }
          }}
        >
          Download as PDF
        </Button>
        <Button
          variant="contained"
          onClick={downloadAsImage}
          style={{ marginLeft: 10, color: 'white' }}
        >
          Download as Image
        </Button>
      </Grid>
    </div>
  );
};

export default GeneratedBulletin;
